jQuery(document).ready(function($) {
    if($('.filters-opener').hasClass('open-on-load')) {
        open_filters();
    }
});

function open_filters(sender) {
    var $ = jQuery.noConflict();
    var a = $('.filters-opener');
    if(sender != undefined) {
        a = $(sender);
    }
    var f = $('.list-filters-wrapper');
    if(sender != undefined) {
        f = $(sender).parents('tr:first').find('.list-filters-wrapper');
    }

    if(a.hasClass('closed')) {
        a.removeClass('closed');
        a.addClass('open');
        f.addClass('open');
    } else {
        a.removeClass('open');
        a.addClass('closed');
        f.removeClass('open');
    }
    return false;
}